import Product from '@/ts/Product'

import Presentation from './includes/Presentation'
import Thumbnails from './includes/Thumbnails'
import useGallery from './logic/useGallery'

function Gallery({ product }: GalleryProps) {
  const { viewport, changeSlide, currentSlide } = useGallery()

  return (
    <div className="relative flex flex-col w-full overflow-hidden md:space-y-10">
      <Presentation
        product={product}
        currentSlide={currentSlide}
        onChange={changeSlide}
      />
      {product.images.length > 1 && (
        <Thumbnails
          ref={viewport}
          product={product}
          onClick={changeSlide}
          currentSlide={currentSlide}
        />
      )}
    </div>
  )
}

interface GalleryProps {
  product: Product
}

export default Gallery
